import React from "react";
import Stat from "../../components/Stat";

function ProduitsKpi() {
  return (
    <div className="container-fluid">
      <h1 className="mb-3" style={{ fontWeight: 400, fontSize: 18 }}>
        Les donnees des differentes PRODUITS
      </h1>
      <Stat label="Produits" />
    </div>
  );
}

export default ProduitsKpi;
